import styles from '../styles.module.scss';

import React, {useEffect, useRef, useState} from "react";
import {getFormattedSeatValue} from "../../helpers/helpers";

interface ButtonOptionProps {
    name: string,
    id: string,
    value: string,
    onChange: any,
    price: string,
    comparePrice: string,
    checked: boolean,
    display: boolean,
    enabled: boolean,
    type: 'radio' | 'checkbox',
    customCompatibility: string
}

const ButtonOption: React.FC = (props: ButtonOptionProps) => {

    const {
        value,
        subtitle,
        diff
    } = getFormattedSeatValue(props.value, props.price, props.comparePrice, props.customCompatibility);

    const styles_override = {}
    // console.log('button', props.name, props.value, props.display);
    if (props.display === false || props.enabled === false) {
        styles_override['display'] = 'none';
    }

    return (
        <div className={`${styles.button_option} ${window.scs_custom_style ? styles.style01 : ''}`}
             style={styles_override}>
            <label htmlFor={props.id}>
                <div className={`${styles.form_control}`}>
                    <input onChange={props.onChange} type={props.type} name={props.name}
                           value={props.value} id={props.id} checked={props.checked}/>
                </div>
                <div className={`${styles.content_wrapper}`}>
                    <div className={`${styles.title_wrapper}`}>
                        <div className={`${styles.title}`}>
                            {`${value}`}
                        </div>
                        <div className={`${styles.sub_title}`}>
                            {`${subtitle}`}
                        </div>
                    </div>
                    {props.comparePrice ? <div className={`${styles.btn_savings}`}>$
                        {(parseFloat(props.comparePrice.replace('$', ''))
                            - parseFloat(props.price.replace('$', ''))).toFixed(0)} Savings</div> : ''}
                    <div className={`${styles.price_wrapper}`}>
                        {props.comparePrice ? (<div className={`${styles.compare_price}`}>
                            {props.comparePrice}
                        </div>) : ''}
                        {props.price ? (<div className={`${styles.price}`}>
                            {props.price}
                        </div>) : ''}
                    </div>
                </div>

            </label>
        </div>
    );
};

export default ButtonOption;

